import React from "react";
import { useState } from "react";
import FinxPay from "../../assests/images/finxpay.png";
import "./login.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Field, ErrorMessage } from "formik";
import TextField from "../../Helper/TextField";
import { useDispatch } from "react-redux/es/exports";
import { AUTH_LOGIN } from "../../redux/auth/types";
import { ToastContainer,toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { isUserAdmin, setUser } from "../../utils/comman/Common";

const Login = () => {
  const distList = process.env.REACT_APP_DISTRIBUTOR;

  const [userId, setUserId] = useState('')
  var distributerList = JSON.parse(distList);
  //console.log('distributerList',Array.isArray(distributerList))
  //console.log("distributerList1", distributerList)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const login = (e) => {

	e.prevenetDefault();
  };
  const numberregex = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const passregex = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/

  const validate = Yup.object({
    id:Yup.string()
    // .matches(numberregex, 'only number is allowed')
    .min(10, 'Min value 10.')
    .required("User Id Is Required"),
    password: Yup.string()
    // .matches(passregex, 'only number is allowed')
      .min(4, "Password Must Be Atleast 4 Characters")
      .required("Password Is Required"),
  });
  isUserAdmin()
  const onSubmitLogin = (values) =>{
   const isAdmin= isUserAdmin(values.id)
    dispatch({ type: AUTH_LOGIN, payload: {values, navigate,dispatch, distributerList,isAdmin} });
  }
  return (
    <div className="login-container">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
            <div className="login-box">
              <div className="login-head">
                <img src={FinxPay} alt="logo" className="img-fluid" />
                <h3>Welcome to FinXpay Admin</h3>
                <p>Login to continue</p>
              </div>

              <Formik
                initialValues={{
                  id: "",
                  password: "",
                }}
                
                validationSchema={validate}
                onSubmit={(values) => {
                  onSubmitLogin(values)
                }}
              >
                {(formik) => (
                  <>
                    <div className="login-form">
                      <Form>
                        <div className=" form-floating">
                          <TextField
                            placeholder="User ID"
                            label="User ID"
                            name="id"
                            type="id"
                          />
                        </div>
                        <div className=" form-floating">
                          <TextField
                            name="password"
                            label="Password"
                            type="password"
                            placeholder="Your Password  abc"
                          />
                        </div>
                        <button className="btn btn-primary" type="submit">
                          Login Now
                        </button>
                      </Form>

                      <p>
                        <a href="#">Forgot password?</a>
                      </p>
                    </div>
                    <ToastContainer />
                  </>
                )}
              </Formik>
            </div>
          </div>
                  
          {/* <div className="col-12">
            <div className="logcopy">
              Copyright &copy; 2022 All rights reserved. <br />
              Powered by Uvva Infotech Pvt. Ltd.
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
